import React, { useState, useRef } from 'react'

const NoteEditor = ({ proxy, apiClient, onSave, onCancel, currentNote }) => {
    const initialNote = (currentNote !== undefined ? currentNote : proxy?.note) || ''
    const [note, setNote] = useState(initialNote)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const inputRef = useRef(null)
    const savedRef = useRef(false)
    const cancelledRef = useRef(false)

    const handleSave = async () => {
        if (isLoading || savedRef.current || cancelledRef.current) return

        if (note === initialNote) {
            onCancel()
            return
        }

        setIsLoading(true)
        setError(null)
        try {
            await apiClient.updateProxyNote(proxy.proxyid, note)
            savedRef.current = true
            onSave(note)
        } catch (err) {
            console.error('Error saving note:', err)
            setError('Failed to save note. Please try again.')
            setTimeout(() => inputRef.current?.focus(), 0)
        } finally {
            setIsLoading(false)
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            handleSave()
        } else if (e.key === 'Escape') {
            cancelledRef.current = true
            onCancel()
        }
    }

    return (
        <div style={{
            position: 'relative',
            width: '100%'
        }}>
            {error && (
                <div style={{
                    color: '#e67c87',
                    fontSize: 'var(--text-xs)',
                    padding: '4px 8px',
                    background: 'rgba(220, 53, 69, 0.1)',
                    border: '1px solid rgba(220, 53, 69, 0.3)',
                    borderRadius: 'var(--radius-sm)',
                    marginBottom: '4px',
                    position: 'absolute',
                    top: '-30px',
                    left: '0',
                    right: '0',
                    zIndex: 1000
                }}>
                    {error}
                </div>
            )}
            <input
                ref={inputRef}
                type="text"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onBlur={handleSave}
                onKeyDown={handleKeyDown}
                placeholder="Add a note..."
                disabled={isLoading}
                size={1}
                style={{
                    background: 'var(--dark-gray)',
                    border: '1px solid var(--light-gray)',
                    borderRadius: 'var(--radius-sm)',
                    color: 'var(--text-light)',
                    padding: '4px 8px',
                    fontSize: 'var(--text-sm)',
                    width: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                    opacity: isLoading ? 0.7 : 1
                }}
                autoFocus
            />
        </div>
    )
}

export default NoteEditor
